var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5313 6.46875C41.5781 4.51562 38.4062 4.51562 36.4531 6.46875L11.4531 31.4688C9.5 33.4219 9.5 36.5937 11.4531 38.5469C13.4062 40.5 16.5781 40.5 18.5312 38.5469L35 22.0625V70C35 72.7656 37.2344 75 40 75C42.7656 75 45 72.7656 45 70V22.0781L61.4688 38.5313C63.4219 40.4844 66.5938 40.4844 68.5469 38.5313C70.5 36.5781 70.5 33.4062 68.5469 31.4531L43.5469 6.45312L43.5313 6.46875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.f5c69891178b61985d9277dd4993ec8b.svg";
export { ForwardRef as ReactComponent };